import Vue from 'vue'
import Router from 'vue-router'
import loginPage from '@/assets/loginPage'
import test from '@/assets/test'
import contentList from '@/assets/contentList'
import userList from '@/assets/userList'
import groupList from '@/assets/groupList'
import editPassword from '@/assets/editPassword'
import userEdit from '@/assets/userEdit'
import groupEdit from '@/assets/groupEdit'
import contentEdit from '@/assets/contentEdit'
import contentQuery from '@/assets/contentQuery'
Vue.use(Router)
//let user = localStorage.getItem("user")
//let commentpont = ""
//let commenttitle = ""
//if(user==null){
//	commentpont = loginPage
//	commenttitle = "登陆"
//}
export default new Router({
	mode: 'history',
	  routes: [
	    {
	      path: '/login',
	      name: 'login',
	      component: loginPage,
	      meta: {
	      		loginPage:true,
	      		doNotAuth:true,
	            title: '登录'
	       }
	    },
	    {
	      path: '/editPassword',
	      name: 'editPassword',
	      component: editPassword,
	      meta: {
	            title: '修改密码'
	       }
	    },
	    {
	      path: '/contentList',
	      name: 'contentList',
	      component: contentList,
	      meta: {
	            title: '文件列表'
	       }
	    },
	    {
	      path: '/',
	      name: 'contentList',
	      component: contentList,
	      meta: {
	            title: '文件列表'
	       }
	    },
	     {
	      path: '/userList',
	      name: 'userList',
	      component: userList,
	      meta: {
	            title: '账号列表'
	       }
	    },
	     {
	      path: '/userEdit',
	      name: 'userEdit',
	      component: userEdit,
	      meta: {
	            title: '编辑用户'
	       }
	    },
	    {
	      path: '/groupList',
	      name: 'groupList',
	      component: groupList,
	      meta: {
	            title: '分组管理'
	       }
	    },
	     {
	      path: '/groupEdit',
	      name: 'groupEdit',
	      component: groupEdit,
	      meta: {
	            title: '编辑分组'
	       }
	    },
	    {
	      path: '/contentEdit',
	      name: 'contentEdit',
	      component: contentEdit,
	      meta: {
	            title: '上传内容'
	       }
	    },
	     {
	      path: '/contentQuery',
	      name: 'contentQuery',
	      component: contentQuery,
	      meta: {
	            title: '查看内容'
	       }
	    },
	    {
	      path: '/test',
	      name: 'test',
	      component: test,
	      meta: {
	            title: '测试'
	       }
	    }
   
  	]
})



// WEBPACK FOOTER //
// ./src/router/index.js